import { connect } from 'react-redux'
import { getUserIsAuthentificated } from 'Modules/user/data/selectors'
import { clearSelectedMarker } from 'Modules/searchMap/actions'
import { selectApplyDisclaimer } from 'Modules/areas/selectors'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import { openRegisterModal, openLoginModal, openEmailVerifyModal } from 'Modules/modals/actions'

import MapListingPopup from './MapListingPopup'

const mapStateToProps = state => (
  {
    userIsAuthentificated: getUserIsAuthentificated(state),
    markerAddressData: state.searchMap.markerAddressData,
    userEmailVerified: state.userData.user.emailVerified,
    isFetchingMarkerAddress: state.searchMap.isFetchingMarkerAddress,
    isBc: selectApplyDisclaimer(state) === 'BC',
    isMobileApp: state.app.isMobileApp,
  }
)
const actions = {
  clearSelectedMarker,
  googleAnalyticsEvent,
  openRegister: openRegisterModal,
  openLogin: openLoginModal,
  openEmailVerifyModal,
}
export default connect(mapStateToProps, actions)(MapListingPopup)
